/* eslint-disable no-dupe-keys */
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import ReactPlayer from 'react-player';
import WhatsAppButton from '../components/WhatsAppButton';
import LandingChatbot from '../components/LandingChatbot';
import { Helmet } from 'react-helmet';
import useFacebookPixel from '../hooks/useFacebookPixel';
import SocialButtons from '../components/SocialButton';
import MicrosoftClarity from '../components/MicrosoftClarity';
import './usuario.css';
import './recuadro.css';
import './AudienciaLanding.css';

const Comoafiliarse = () => {
  const { usuario } = useParams();
  useFacebookPixel(usuario);
  const { trackContact, trackLead } = useFacebookPixel(usuario);
  const [data, setData] = useState(null);
  const [userdata, setUserdata] = useState({});
  const [Pixels, setPixels] = useState('');
  const [Clarity, setClarity] = useState('');
  const playerRef = useRef(null);

  const fetchUserInfo = async () => {
    try {
      const response = await axios.get(
        `https://api.mrcirp.com/public/infocampanas/${usuario}`
      );
      setUserdata(response.data[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`https://api.mrcirp.com/public/usuariolanding/${usuario}`);
      setData(response.data[0]);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const pixelsuser = async () => {
    try {
      const response = await axios.get(
        `https://api.mrcirp.com/public/userpixels/${usuario}`
      );
      setPixels(response.data[0]);
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  const clarityuser = async () => {
    try {
      const response = await axios.get(
        `https://api.mrcirp.com/public/userclarity/${usuario}`
      );
      setClarity(response.data[0]);
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUserInfo();
    pixelsuser();
    clarityuser();
  }, [usuario]);

  if (!data) {
    return <div>Loading...</div>;
  }

  // Parsear servicios_items de éxito
  let exitoServiciosItems = [];
  if (data.exito_servicios_items) {
    try {
      exitoServiciosItems = typeof data.exito_servicios_items === 'string' 
        ? JSON.parse(data.exito_servicios_items) 
        : data.exito_servicios_items;
      if (!Array.isArray(exitoServiciosItems)) exitoServiciosItems = [];
    } catch (e) {
      console.error('Error parsing exito_servicios_items:', e);
    }
  }

  const hasAnySocialLink = 
    (userdata && userdata.pdf) || 
    (userdata && userdata.facebook) || 
    (userdata && userdata.instagram) || 
    (userdata && userdata.linkedin) || 
    (userdata && userdata.tiktok) || 
    (userdata && userdata.calendly);

  return (
    <div style={styles.container}>
      <Helmet>
        <title>{usuario} - Cómo Afiliarse</title>
        <meta name="description" content={`Pixels: ${Pixels}`} />
      </Helmet>
      {Clarity?.clarity && <MicrosoftClarity trackingId={Clarity.clarity} />}
      {/* Banner Section */}
      <div 
        style={{
          ...styles.bannerSection,
          backgroundImage: data.exito_banner_imagen_url ? `url(${data.exito_banner_imagen_url})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: 'auto',
          paddingBottom: '60px'
        }}
      >
        <div style={styles.content}>
          {/* Título y subtítulo del banner encima del video */}
          {(data.exito_banner_titulo || data.exito_banner_subtitulo) && (
            <div style={styles.bannerContent}>
              {data.exito_banner_titulo && (
                <h1 
                  style={styles.bannerTitle}
                  dangerouslySetInnerHTML={{ __html: data.exito_banner_titulo }}
                />
              )}
              {data.exito_banner_subtitulo && (
                <p 
                  style={styles.bannerSubtitle}
                  dangerouslySetInnerHTML={{ __html: data.exito_banner_subtitulo }}
                />
              )}
            </div>
          )}

          {/* Video de Cómo Afiliarse */}
          <div style={{ maxWidth: '800px', margin: '40px auto 0', width: '100%' }}>
            {data.urlcomoafiliarse && (
              <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                <ReactPlayer
                  ref={playerRef}
                  url={data.urlcomoafiliarse}
                  width="100%"
                  height="100%"
                  controls={true}
                  style={{ position: 'absolute', top: 0, left: 0 }}
                />
              </div>
            )}
            
            {/* Botón UNIRSE AL NEGOCIO */}
            {data.urlBotonNegocio && (
              <div style={{ margin: '30px auto 0', width: '100%', textAlign: 'center' }}>
                <a 
                  href={data.urlBotonNegocio} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={styles.joinButton}
                  onClick={trackLead}
                >
                  UNIRSE AL NEGOCIO
                </a>
              </div>
            )}
          </div>

        </div>
      </div>

      {/* Sección de Servicios */}
      {data.exito_servicios_titulo && (
        <section className="servicios-section">
          <div className="container">
            <div className="section-header">
              <h2 
                className="section-title"
                dangerouslySetInnerHTML={{ __html: data.exito_servicios_titulo || '' }}
              />
              {data.exito_servicios_descripcion && (
                <p 
                  className="section-description"
                  dangerouslySetInnerHTML={{ __html: data.exito_servicios_descripcion }}
                />
              )}
            </div>
            
            {exitoServiciosItems.length > 0 && (
              <div className="servicios-grid">
                {exitoServiciosItems.map((item, index) => (
                  <div key={index} className="servicio-card">
                    <h3 
                      className="servicio-title"
                      dangerouslySetInnerHTML={{ __html: item.titulo || '' }}
                    />
                    <p 
                      className="servicio-description"
                      dangerouslySetInnerHTML={{ __html: item.descripcion || '' }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Izquierda) */}
      {data.exito_dos_columnas_titulo && (
        <section className="dos-columnas-section">
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-left">
                {data.exito_dos_columnas_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.exito_dos_columnas_imagen} 
                      alt={data.exito_dos_columnas_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.exito_dos_columnas_titulo || '' }}
                />
                {data.exito_dos_columnas_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.exito_dos_columnas_descripcion }}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Derecha) */}
      {data.exito_dos_columnas_derecha_titulo && (
        <section 
          className="dos-columnas-section reverse"
          style={{
            backgroundImage: data.exito_dos_columnas_derecha_fondo_imagen ? `url(${data.exito_dos_columnas_derecha_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.exito_dos_columnas_derecha_titulo || '' }}
                />
                {data.exito_dos_columnas_derecha_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.exito_dos_columnas_derecha_descripcion }}
                  />
                )}
              </div>
              <div className="column-left">
                {data.exito_dos_columnas_derecha_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.exito_dos_columnas_derecha_imagen} 
                      alt={data.exito_dos_columnas_derecha_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            <p className="footer-text">
              © 2024 KATANA - Constructor de Ingresos Residuales Perpetuos
            </p>
          </div>
        </div>
      </footer>

      <WhatsAppButton
        phoneNumber={userdata?.whatsapp}
        message="Hola, me gustaría obtener más información."
        onContactClick={trackContact}
      />
      <LandingChatbot />
      {hasAnySocialLink && (
        <SocialButtons
          pdfUrl={userdata?.pdf || undefined}
          facebookUrl={userdata?.facebook || undefined}
          instagramUrl={userdata?.instagram || undefined}
          linkedinUrl={userdata?.linkedin || undefined}
          tiktokUrl={userdata?.tiktok || undefined}
          calendlyUrl={userdata?.calendly || undefined}
          onContactClick={(network) => console.log(`Se hizo clic en ${network}`)}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    color: "#333",
  },
  bannerSection: {
    padding: '80px 0',
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    minHeight: 'auto',
    paddingBottom: '60px',
  },
  bannerContent: {
    maxWidth: '800px',
    margin: '0 auto 40px',
  },
  bannerTitle: {
    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
    fontWeight: 'bold',
    marginBottom: '20px',
    textShadow: '2px 2px 8px rgba(0, 0, 0, 0.7)',
    color: 'white !important',
  },
  bannerSubtitle: {
    fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
    marginBottom: '20px',
    opacity: 0.95,
    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.6)',
    color: 'white !important',
  },
  content: {
    textAlign: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%',
    padding: '40px 20px',
    backgroundColor: 'transparent',
  },
  joinButton: {
    display: "inline-block",
    padding: "18px 36px",
    fontSize: "20px",
    fontWeight: "bold",
    cursor: "pointer",
    backgroundColor: "#00f60a",
    color: "#000",
    border: "3px solid #000",
    borderRadius: "8px",
    textDecoration: "none",
    transition: "all 0.3s",
    boxShadow: "0 4px 12px rgba(0, 246, 10, 0.4)",
    animation: "pulse 1.5s infinite",
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      boxShadow: '0 4px 12px rgba(0, 246, 10, 0.4)',
    },
    '50%': {
      transform: 'scale(1.05)',
      boxShadow: '0 6px 16px rgba(0, 246, 10, 0.6)',
    },
    '100%': {
      transform: 'scale(1)',
      boxShadow: '0 4px 12px rgba(0, 246, 10, 0.4)',
    },
  },
};

export default Comoafiliarse;
